import React from "react";
import * as Sentry from "@sentry/react";
import { AlertTriangle } from "lucide-react";

function ErrorFallback({ error, resetError }) {
  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", background: "var(--bg, #f8fafc)", padding: 24,
    }}>
      <div style={{
        maxWidth: 480, width: "100%", background: "#fff",
        borderRadius: 16, padding: 40, boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
        textAlign: "center",
      }}>
        <div style={{
          width: 56, height: 56, borderRadius: "50%", background: "#fff7ed",
          display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px",
        }}>
          <AlertTriangle size={26} color="#ea580c" />
        </div>
        <h2 style={{ fontSize: 20, fontWeight: 700, color: "#0f172a", marginBottom: 8 }}>
          Something went wrong
        </h2>
        <p style={{ fontSize: 14, color: "#64748b", marginBottom: 8 }}>
          This error has been reported automatically. Our team will look into it.
        </p>
        {error?.message && (
          <div style={{ marginBottom: 24 }}>
            <p style={{
              fontSize: 12, color: "#94a3b8", background: "#f1f5f9",
              borderRadius: 8, padding: "8px 12px", marginBottom: 0, fontFamily: "monospace",
            }}>
              {error.name && <strong style={{ color: "#dc2626" }}>{error.name}: </strong>}
              {error.message}
            </p>
            {error.stack && (
              <details style={{ marginTop: 8 }}>
                <summary style={{
                  fontSize: 11, color: "#94a3b8", cursor: "pointer",
                  textAlign: "left", userSelect: "none",
                }}>
                  Show stack trace
                </summary>
                <pre style={{
                  fontSize: 10, color: "#64748b", background: "#f8fafc",
                  borderRadius: 8, padding: "10px 12px", marginTop: 6,
                  textAlign: "left", overflowX: "auto", maxHeight: 200, overflowY: "auto",
                  fontFamily: "monospace", whiteSpace: "pre-wrap", wordBreak: "break-all",
                }}>
                  {error.stack}
                </pre>
              </details>
            )}
          </div>
        )}
        <button
          onClick={resetError}
          className="btn-primary"
          style={{ minWidth: 140 }}
          data-testid="error-boundary-retry-btn"
        >
          Try again
        </button>
        <div style={{ marginTop: 16 }}>
          <button
            onClick={() => window.location.href = "/"}
            style={{ background: "none", border: "none", color: "#4f46e5", cursor: "pointer", fontSize: 13 }}
          >
            Go to dashboard
          </button>
        </div>
      </div>
    </div>
  );
}

export function AppErrorBoundary({ children }) {
  return (
    <Sentry.ErrorBoundary
      beforeCapture={(scope) => scope.setTag("error_area", "app")}
      fallback={ErrorFallback}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
